import request from '@/utils/axios'
/**
 * 获取公共bucket的STS
 * @param {*} data
 * @returns
 */
// export function getCommonOssTokenApi() {
//     return request({
//         url: '/commons/oss/common/sts',
//         method: 'get'
//     })
// }
// /**
//  * 获取私有bucket的STS
//  * @param {*} data
//  * @returns
//  */
// export function getPrivateOssTokenApi() {
//     return request({
//         url: '/commons/oss/private/sts',
//         method: 'get'
//     })
// }
/**
 * 获取私库stsToken
 * @param {*} data
 * @returns
 */
export function commonsOssStsAPI(data) {
    return request({
        url: '/commons/oss/sts',
        method: 'post',
        data
    })
}
